export default __webpack_public_path__ + "9ed39223a132ad2e6a1a56e071585d8b.svg";